import React from "react"

export function Edit(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_1202_1989)">
        <path
          d="M11.2189 6.31631L11.5279 6.00732L10.6009 5.08037L8.90288 3.38232L7.97593 2.45537L7.66695 2.76436L7.04898 3.38232L1.6021 8.8292C1.31773 9.11357 1.10991 9.46631 0.995071 9.85185L0.0271024 13.144C-0.041257 13.3737 0.0216336 13.6226 0.193899 13.7921C0.366165 13.9616 0.612259 14.0245 0.841946 13.9589L4.1314 12.9909C4.51695 12.8761 4.86968 12.6683 5.15406 12.3839L10.6009 6.93701L11.2189 6.31631ZM4.37476 10.921L4.12593 11.5417C4.01655 11.6265 3.89351 11.6894 3.76226 11.7304L1.62398 12.3593L2.25288 10.2237C2.29116 10.0897 2.35679 9.9667 2.44156 9.86006L3.06226 9.61123V10.4862C3.06226 10.7269 3.25913 10.9237 3.49976 10.9237H4.37476V10.921ZM9.91734 0.51123L9.52359 0.907715L8.90562 1.52568L8.5939 1.83467L9.52085 2.76162L11.2189 4.45967L12.1459 5.38662L12.4548 5.07764L13.0728 4.45967L13.4693 4.06318C14.1529 3.37959 14.1529 2.27217 13.4693 1.58857L12.3947 0.51123C11.7111 -0.172363 10.6037 -0.172363 9.92007 0.51123H9.91734ZM8.62124 5.10498L4.68374 9.04248C4.51421 9.21201 4.2353 9.21201 4.06577 9.04248C3.89624 8.87295 3.89624 8.59404 4.06577 8.42451L8.00327 4.48701C8.17281 4.31748 8.45171 4.31748 8.62124 4.48701C8.79077 4.65654 8.79077 4.93545 8.62124 5.10498Z"
          fill="#4F4F4F"
        />
      </g>
      <defs>
        <clipPath id="clip0_1202_1989">
          <path d="M0 0H14V14H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
